import { useEffect, useRef, useState } from "react";
import { AppSettings } from "../../../app-setting";
import * as bootstrap from "bootstrap";
import { NavigationHelper } from "../../../shared-module/helpers/navigation-helper";
import { useNavigate } from "react-router-dom";
import { ShowThen } from "../../../shared-module/components/show-then/show-then.component";
import $ from "jquery";
import "./../../../assets/scripts/print-this";
import { GatewayOapApi } from "../../../shared-module/models/gateway-oap-api.models";
import { Utility } from "../../../shared-module/helpers/utility";
import { AppStateService } from "../../services/app-state-service";
import { SessionService } from "shared-module/services/session.service";
import BdsCheckbox from "shared-module/components/checkbox/bds-checkbox.component";
import fssaLogo from "../../../assets/images/fssa_logo_cut.png";
import bdsGraphic from "../../../assets/images/bds_graphic.png";

/* ─── Inline SVG Icons ──────────────────────────────────────── */
const ShieldIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const UserIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#b91c1c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const AccessibilityIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="4" r="1.5" />
    <path d="M7 8h10" />
    <path d="M12 8v5" />
    <path d="M9 20l3-7 3 7" />
  </svg>
);

const HeartIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const CommunityIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const ChevronDown = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PrintIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 6 2 18 2 18 9" />
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);

/* ─── Accordion Item ────────────────────────────────────────── */
function AccordionItem({ title, children, defaultOpen = false }: { title: string; children: React.ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="bds-accordion-item" style={{
      border: '1px solid #e2e8f0',
      borderRadius: '0.75rem',
      overflow: 'hidden',
      marginBottom: '0.75rem',
      transition: 'box-shadow 0.2s ease',
    }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-100 d-flex align-items-center justify-content-between"
        style={{
          cursor: 'pointer',
          fontFamily: 'Inter, system-ui, sans-serif',
          padding: '1rem 1.25rem',
          background: open ? '#f8fafc' : '#ffffff',
          border: 'none',
          textAlign: 'left',
        }}
        aria-expanded={open}
      >
        <span style={{ fontWeight: 600, color: '#1e293b', fontSize: '1.05rem' }}>{title}</span>
        <span style={{ transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.25s ease', flexShrink: 0 }}>
          <ChevronDown />
        </span>
      </button>
      <div style={{
        maxHeight: open ? '600px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.35s ease',
      }}>
        <div style={{ padding: '0 1.25rem 1.25rem', fontFamily: 'Inter, system-ui, sans-serif' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

/* ─── SVG Wave Divider ──────────────────────────────────────── */
const WaveDivider = () => (
  <div style={{ lineHeight: 0, overflow: 'hidden', position: 'relative', marginTop: '-1px' }}>
    <svg viewBox="0 0 1440 120" preserveAspectRatio="none" style={{ width: '100%', height: '80px', display: 'block' }}>
      <path
        d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z"
        fill="#f8fafc"
      />
    </svg>
  </div>
);

/* ═══════════════════════════════════════════════════════════════
   HOME PAGE COMPONENT
   ═══════════════════════════════════════════════════════════════ */
function HomePage() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<GatewayOapApi.UserModel>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [confirmed, setConfirmed] = useState(false);

  const navigate = useNavigate();
  const tooltipRef = useRef();

  function handleConfirmation(): void {
    setConfirmed(!confirmed);
  }

  function clearSessionValues(): Promise<void> {
    sessionStorage.removeItem("applicationTimeout");
    sessionStorage.removeItem("isGuestUser");
    sessionStorage.removeItem("guestSessionId");
    sessionStorage.removeItem("fromNbar");
    return Promise.resolve();
  }

  useEffect(() => {
    bindPrintButton();

    if (sessionStorage.getItem("applicationTimeout")) {
      Utility.alert(
        "Application Timeout",
        "Your browser was redirected due to inactivity during your last session. Registered users may continue editing the application from the dashboard; guest applicants will need to begin a new application.",
        clearSessionValues
      );
    }

    const tooltip = bootstrap.Tooltip.getOrCreateInstance(tooltipRef.current, {
      boundary: document.body,
      container: '[data-bs-toggle="tooltip"]',
      trigger: "hover",
    });

    setIsLoading(true);
    Utility.showLoadingOverlay();

    Promise.all([SessionService.isAuthenticated(), SessionService.getProfile()])
      .then((response) => {
        setIsAuthenticated(response[0]);
        setUser(response[1]);
        return Promise.resolve(true);
      })
      .finally(() => {
        setIsLoading(false);
        Utility.hideLoadingOverlay();
      });

    return () => {
      tooltip.dispose();
    };
  }, []);

  function handleLogout() {
    NavigationHelper.gotoUnauthorization(navigate);
  }

  function handleStartApplication() {
    if (confirmed) {
      AppStateService.setShowGuestApplicationDisclaimer(true);
      NavigationHelper.gotoStartApplication(navigate);
    }
  }

  function handleLogin() {
    NavigationHelper.gotoAuthorization(navigate);
  }

  function bindPrintButton() {
    $("#print-instructions").on("click", function () {
      ($("#instructions") as any).printThis({
        debug: false,
        importCSS: false,
        header: "<h3>" + AppSettings.bdsAcronym + " Gateway Instructions</h3>",
      });
      return false;
    });
  }

  /* ─── RENDER ──────────────────────────────────────────────── */
  return (
    <div className="bds-home-redesign" style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>

      {/* Print-only content (hidden visually) */}
      <div id="instructions" style={{ display: 'none' }}>
        <style>{"@media print { .no-print, .no-print * { display: none !important; } } body { font-size: 14px; }"}</style>
        <h2>About This Application</h2>
        <p>Welcome to the online application for services available through the {AppSettings.bdsName} ({AppSettings.bdsAcronym}). This application is used to apply for waiver services and/or group home placement.</p>
      </div>

      {/* ═══════════════════════════════════════════════════════════
          HERO — BDS graphic left, text right, FSSA watermark
          ═══════════════════════════════════════════════════════════ */}
      <section style={{
        background: 'linear-gradient(145deg, #0d1f42 0%, #1a3769 40%, #1e5f74 75%, #0d7680 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* FSSA seal — large transparent watermark */}
        <div style={{
          position: 'absolute', right: '18%', top: 'calc(2rem - 5px)',
          opacity: 0.12, pointerEvents: 'none',
        }}>
          <img src={fssaLogo} alt="" aria-hidden="true" style={{ height: '295px', width: 'auto' }} />
        </div>

        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '2rem 1.5rem 1.5rem', position: 'relative' }}>
          <div className="d-flex align-items-center gap-4 flex-wrap flex-md-nowrap">
            {/* BDS graphic — left, large */}
            <div className="flex-shrink-0 d-none d-md-block">
              <img src={bdsGraphic} alt="Bureau of Disabilities Services"
                style={{ height: '220px', width: 'auto', filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.3))' }} />
            </div>

            {/* Text — right */}
            <div>
              <div className="d-flex align-items-center gap-1 mb-1">
                <img src={fssaLogo} alt="FSSA" style={{ height: '22px', width: 'auto', opacity: 0.8 }} />
                <span style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.7rem', fontWeight: 500, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                  Indiana Family &amp; Social Services Administration
                </span>
              </div>
              <h1 style={{ fontSize: '2.25rem', fontWeight: 800, color: '#fff', lineHeight: 1.2, marginBottom: '0.4rem', letterSpacing: '-0.01em' }}>
                Apply for Disability <span style={{ color: '#5dd9c1' }}>Services</span>
              </h1>
              <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.75)', lineHeight: 1.5, marginBottom: 0, maxWidth: '480px' }}>
                Connecting Hoosiers with developmental and intellectual disabilities to waiver services, group home placement, and community support.
              </p>
            </div>
          </div>
        </div>

        <WaveDivider />
      </section>

      {/* ═══════════════════════════════════════════════════════════
          WELCOME BACK (authenticated)
          ═══════════════════════════════════════════════════════════ */}
      <ShowThen when={!isLoading && isAuthenticated}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '1rem 1.5rem 0' }}>
          <div style={{
            background: '#e6f5f6', borderRadius: '0.5rem', padding: '0.75rem 1.25rem',
            border: '1px solid rgba(13,118,128,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem',
          }}>
            <span style={{ fontSize: '0.9rem', color: '#1e293b' }}>
              Welcome back, <strong>{user && (user.firstName + " " + user.lastName)}</strong>
            </span>
            <div className="d-flex gap-2">
              <button type="button" onClick={() => NavigationHelper.gotoDashboard(navigate)} className="bds-btn-teal" style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}>
                My Dashboard
              </button>
              <button type="button" onClick={handleLogout} style={{ background: 'none', border: '1px solid #94a3b8', borderRadius: '0.5rem', padding: '0.4rem 1rem', fontSize: '0.85rem', color: '#475569', cursor: 'pointer' }}>
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </ShowThen>

      {/* ═══════════════════════════════════════════════════════════
          APPLICATION PATH CARDS
          ═══════════════════════════════════════════════════════════ */}
      <section id="guest-section" style={{ background: '#f8fafc', padding: '2.5rem 1.5rem 3rem' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#1e293b', marginBottom: '1.25rem', textAlign: 'center' }}>
            Choose How to Apply
          </h2>

          <div className="row g-3 justify-content-center">
            {/* ── Access Indiana Card ──────────────────────── */}
            <div className="col-12 col-md-6">
              <div className="bds-path-card bds-path-card--recommended h-100">
                <div className="bds-path-card__accent bds-path-card__accent--teal" />
                <div style={{ padding: '1.5rem' }}>
                  <div className="mb-2">
                    <span className="bds-path-card__badge" style={{ position: 'static', display: 'inline-block' }}>Recommended</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div style={{ color: '#0d7680' }}><ShieldIcon /></div>
                    <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>Apply with Access Indiana</h3>
                  </div>

                  <ul className="bds-checklist" style={{ marginBottom: '1.25rem' }}>
                    {['Save progress & return anytime', 'Upload & manage documents', 'Track application status', 'Secure access to your info'].map((item, i) => (
                      <li key={i} className="bds-checklist__item" style={{ fontSize: '0.875rem', marginBottom: '0.3rem' }}>
                        <span className="bds-checklist__icon"><CheckIcon /></span><span>{item}</span>
                      </li>
                    ))}
                  </ul>

                  <ShowThen when={!isLoading && !isAuthenticated}>
                    <button type="button" onClick={handleLogin} className="bds-btn-teal w-100" style={{ padding: '0.65rem 1.5rem', fontSize: '0.9rem' }}>
                      Login with Access Indiana
                    </button>
                    <p className="text-center mt-2" style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: 0 }}>
                      No account? <a href={NavigationHelper.routes.registeration} target="_blank" rel="noreferrer" style={{ color: '#0d7680', fontWeight: 600, textDecoration: 'none' }}>Create one free</a>
                    </p>
                  </ShowThen>
                  <ShowThen when={!isLoading && isAuthenticated}>
                    <button type="button" onClick={() => NavigationHelper.gotoDashboard(navigate)} className="bds-btn-teal w-100" style={{ padding: '0.65rem 1.5rem', fontSize: '0.9rem' }}>
                      Go to My Dashboard
                    </button>
                  </ShowThen>
                </div>
              </div>
            </div>

            {/* ── Guest Card ──────────────────────────────── */}
            <div className="col-12 col-md-6">
              <div className="bds-path-card h-100">
                <div className="bds-path-card__accent bds-path-card__accent--gray" />
                <div style={{ padding: '1.5rem' }}>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div style={{ color: '#64748b' }}><UserIcon /></div>
                    <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>Apply as a Guest</h3>
                  </div>

                  <ul className="bds-checklist" style={{ marginBottom: '1rem' }}>
                    <li className="bds-checklist__item" style={{ fontSize: '0.875rem', marginBottom: '0.3rem' }}>
                      <span className="bds-checklist__icon"><CheckIcon /></span><span>No account required — start immediately</span>
                    </li>
                    <li className="bds-checklist__item bds-checklist__item--muted" style={{ fontSize: '0.875rem', marginBottom: '0.3rem' }}>
                      <span className="bds-checklist__icon"><XIcon /></span><span>Cannot save progress or upload documents</span>
                    </li>
                    <li className="bds-checklist__item bds-checklist__item--muted" style={{ fontSize: '0.875rem', marginBottom: '0.3rem' }}>
                      <span className="bds-checklist__icon"><XIcon /></span><span>15-minute inactivity timeout</span>
                    </li>
                  </ul>

                  <div style={{ marginBottom: '0.75rem' }}>
                    <BdsCheckbox
                      id="confirmInstructions"
                      name="confirmInstructions"
                      checked={confirmed}
                      onChange={handleConfirmation}
                      label="I have read the application requirements."
                    />
                  </div>

                  <div ref={tooltipRef} data-bs-toggle="tooltip" data-bs-offset="0,10"
                    data-bs-title="Please confirm you have read the requirements.">
                    <button type="button" disabled={!confirmed} onClick={handleStartApplication}
                      id="start-application" className="bds-btn-primary-orange w-100"
                      style={{ padding: '0.65rem 1.5rem', fontSize: '0.9rem', opacity: confirmed ? 1 : 0.5, cursor: confirmed ? 'pointer' : 'not-allowed' }}>
                      <ShowThen when={isAuthenticated}>Start a New Application</ShowThen>
                      <ShowThen when={!isAuthenticated}>Start Guest Application</ShowThen>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          FEATURES — compact row
          ═══════════════════════════════════════════════════════════ */}
      <section style={{ background: '#fff', padding: '2.5rem 1.5rem' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div className="row g-3">
            {[
              { icon: <AccessibilityIcon />, color: '#0d7680', bg: '#e6f5f6', title: 'Equal Access', desc: 'Same opportunity for services regardless of circumstance.' },
              { icon: <HeartIcon />, color: '#c94a14', bg: '#fdf0eb', title: 'Person-Centered', desc: 'Built around each individual\'s choices and goals.' },
              { icon: <CommunityIcon />, color: '#1a3769', bg: '#e8edf5', title: 'Community Support', desc: 'Live, work, learn, and thrive in your community.' },
            ].map((item, i) => (
              <div className="col-12 col-md-4" key={i}>
                <div className="d-flex align-items-start gap-3" style={{ padding: '1rem' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '0.75rem', background: item.bg, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {item.icon}
                  </div>
                  <div>
                    <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e293b', marginBottom: '0.2rem' }}>{item.title}</h3>
                    <p style={{ fontSize: '0.85rem', color: '#64748b', lineHeight: 1.5, margin: 0 }}>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          PREPARE YOUR INFORMATION (ACCORDION)
          ═══════════════════════════════════════════════════════════ */}
      <section style={{ background: '#f8fafc', padding: '2.5rem 1.5rem' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#1e293b', marginBottom: '1rem', textAlign: 'center' }}>
            Prepare Your Information
          </h2>

          <AccordionItem title="Required Information" defaultOpen={true}>
            <ul style={{ color: '#334155', paddingLeft: '1.25rem', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: 0 }}>
              <li>Applicant's full name, SSN, and date of birth</li>
              <li>Current physical address (and mailing address if different)</li>
              <li>Contact information (phone and/or email)</li>
              <li>Age when diagnosed with a developmental or intellectual disability</li>
              <li>Brief description of how the disability affects daily life</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="Guardian or Legal Representative">
            <p style={{ color: '#475569', marginBottom: '0.5rem', fontSize: '0.9rem' }}>If the applicant is a minor or has a legal representative:</p>
            <ul style={{ color: '#334155', paddingLeft: '1.25rem', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: 0 }}>
              <li>Name, relationship, address, and contact info of guardian/representative</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="Optional Information">
            <p style={{ color: '#475569', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
              Not required. Helps us improve services — not used for eligibility decisions:
            </p>
            <ul style={{ color: '#334155', paddingLeft: '1.25rem', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: 0 }}>
              <li>Medicaid status, gender, marital status, education</li>
              <li>Race/ethnicity, preferred language, vocational rehab history</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="After You Submit">
            <p style={{ color: '#334155', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: 0 }}>
              Review your answers, then submit. You'll receive a confirmation and can download a copy.
              See <a href={AppSettings.Link_DDRSForms} target="_blank" rel="noreferrer" style={{ color: '#0d7680', fontWeight: 600 }}>supporting documents</a> and
              next steps. You may decline services or stop anytime.
            </p>
          </AccordionItem>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          HELP STRIP
          ═══════════════════════════════════════════════════════════ */}
      <section style={{ background: '#fff', padding: '1.5rem', borderTop: '1px solid #e2e8f0' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div className="d-flex flex-wrap justify-content-center align-items-center gap-3" style={{ fontSize: '0.9rem' }}>
            <a href={AppSettings.Link_DistrictOffices} target="_blank" rel="noreferrer" className="bds-help-link" style={{ padding: '0.5rem 1rem' }}>
              <MapPinIcon /> Find Your District Office
            </a>
            <a href={AppSettings.Link_DDRSLanding} target="_blank" rel="noreferrer" className="bds-help-link" style={{ padding: '0.5rem 1rem' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              Learn About BDS
            </a>
            <button type="button" id="print-instructions" className="bds-help-link no-print" style={{ padding: '0.5rem 1rem', cursor: 'pointer' }}>
              <PrintIcon /> Print
            </button>
          </div>
        </div>
      </section>


    </div>
  );
}

export default HomePage;
